import country from "fragments/vendors/country"
import { gql } from "graphql-tag"

const GET_COUNTRY_BY_ID = gql`
  ${country}

  query getCountryById($id: ID!) {
    getCountryById(id: $id) {
      ...Country
    }
  }
`

export default GET_COUNTRY_BY_ID
